export enum CrossSaleTracking {
    CrossSellCategoryEvent = 'X - Sell',
    CrossSellClick = 'Cross Sell - Click',
    SeeAllClick = 'See All - Click',
    ShowMoreClick = 'Show More - Click',
    ShowLessClick = 'Show Less - Click',

    Virtuals = 'Virtuals',
    VirtualGames = 'Virtual Games',
    Casino = 'Casino',

    Vyml = 'Virtuals You Might Like',
    LinkBanner = 'Link Banner',
    Gyml = 'Games You Might Like',
    JackpotBanner = 'Jackpot Banner',

    TopPage = 'Top Page',
    MidPage = 'Mid Page',
    BottomPage = 'Bottom Page',

    Fralis = 'Fralis',

    GameSectionGyml = 'sports/GamesYouMightLike',
    GameSectionLinkBanner = 'sports/LinkBanner',
    GameSectionJackpotBanner = 'sports/JackpotBanner',
    GameSectionVyml = 'sports/VirtualsYouMightLike',
    GameSectionOnDemand = 'sports/OnDemand',
}
